//
//
//
//


import { infoToastPublish } from "@/assets/js/appFunc";

export default {
    name: "SmartContractContainer",
    mounted() {
        this.$root.$on("scNavigate", object => {
            this.$router.push({ name: "smartContractDesigner", params: { objectForFunction: object } });
        });
    },
    activated() {
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
    },
    deactivated() {
        this.$root.$off("backendWebsocketEvents-publishedApp");
    }
};
